import React, { lazy } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import BarraNavegacion from "Componentes/BarraNavegacion";
import DashBoard from "DashBoard/DashBoard";
import Login from "Login/Login";
import { peticionGet } from "Componentes/ComponenteAxios";

// Definición de rutas protegidas con lazy load
const rutasProtegidas = [
  {
    base: "Agenda",
    listado: lazy(() => import("Agenda/AgendaPrincipal")),
  },
  {
    base: "Usuarios",
    listado: lazy(() => import("Usuarios/UsuarioListado")),
    nuevo: lazy(() => import("Usuarios/UsuarioNuevo")),
    edicion: lazy(() => import("Usuarios/UsuarioEdicion")),
  },
  {
    base: "Clientes",
    listado: lazy(() => import("Clientes/ClienteListado")),
    nuevo: lazy(() => import("Clientes/ClienteNuevo")),
    edicion: lazy(() => import("Clientes/ClienteEdicion")),
  },
  {
    base: "Pedidos",
    listado: lazy(() => import("Pedidos/PedidoListado")),
    nuevo: lazy(() => import("Pedidos/PedidoNuevo")),
    // edicion: lazy(() => import("Pedidos/PedidoEdicion")),
  },
  {
    base: "Productos",
    listado: lazy(() => import("Productos/ProductoListado")),
    nuevo: lazy(() => import("Productos/ProductoNuevo")),
    edicion: lazy(() => import("Productos/ProductoEdicion")),
  },
  {
    base: "Comerciales",
    listado: lazy(() => import("Comerciales/ComercialListado")),
    edicion: lazy(() => import("Comerciales/ComercialEdicion")),
  },
  {
    base: "Jornadas",
    listado: lazy(() => import("Jornadas/JornadaListado")),
    nuevo: lazy(() => import("Jornadas/JornadaNuevo")),
    edicion: lazy(() => import("Jornadas/JornadaEdicion")),
  },
  {
    base: "MediosMecanicos",
    listado: lazy(() => import("MediosMecanicos/MediosMecanicosListado")),
    nuevo: lazy(() => import("MediosMecanicos/MediosMecanicosNuevo")),
    edicion: lazy(() => import("MediosMecanicos/MediosMecanicosEdicion")),
  },
  {
    base: "Mercancias",
    listado: lazy(() => import("Mercancias/MercanciasListado")),
    nuevo: lazy(() => import("Mercancias/MercanciasNuevo")),
    edicion: lazy(() => import("Mercancias/MercanciasEdicion")),
  },
  {
    base: "Tarifas",
    listado: lazy(() => import("Tarifas/TarifaListado")),
    // nuevo: lazy(() => import("Tarifas/TarifasNuevo")),
    // edicion: lazy(() => import("Tarifas/TarifasEdicion")),
  },
  {
    base: "TiposOperativa",
    listado: lazy(() => import("TiposOperativa/TiposOperativaListado")),
    nuevo: lazy(() => import("TiposOperativa/TiposOperativaNuevo")),
    edicion: lazy(() => import("TiposOperativa/TiposOperativaEdicion")),
  },
];

// Componente de ruta protegida

// SI NO HAY SESSION de tarifaActiva busca la tarifa activa y lo setea
// NO LO HAGO EN EL LOGIN XQ al ser sesion se pierde al cerrar el navegador, y el token no se pierde .............

const ProtectedRoute = ({ children, requiresRole }) => {
  // if (!sessionStorage.getItem("idTarifaActiva")) {
  //   peticionGet("/tarifas").then(({ peticion, error }) => {
  //     if (!error) {
  //       const tarifas = peticion.datos || [];
  //       const tarifaActiva = tarifas.find((t) => t.activa === "Si");

  //       if (tarifaActiva) {
  //         sessionStorage.setItem("idTarifaActiva", tarifaActiva.id);
  //       }
  //     }
  //   });
  // }

  const token = localStorage.getItem(process.env.REACT_APP_TOKEN_KEY);
  const role = localStorage.getItem("rol");

  const handleLogout = () => {
    localStorage.removeItem(process.env.REACT_APP_TOKEN_KEY);
    window.location.href = "/login";
  };

  if (!token) {
    return <Navigate to="/login" replace />;
  }
  // ↓ Control de rol (si se pide rol)
  if (requiresRole) {
    const allowed = Array.isArray(requiresRole)
      ? requiresRole.includes(role)
      : role === requiresRole;

    if (!allowed) return <Navigate to="/" replace />; // o a /403 si tienes una página 403
  }
  return (
    <>
      <BarraNavegacion onLogout={handleLogout} />
      <div style={{ marginTop: "20px" }}>{children}</div>
    </>
  );
};
const adminOnly = ["Usuarios", "Empresas"]; // ← bases solo para SuperAdmin
const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />

        {/* Ruta principal protegida */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <DashBoard />
            </ProtectedRoute>
          }
        />

        {/* Rutas protegidas generadas dinámicamente */}
        {rutasProtegidas.map(({ base, listado, nuevo, edicion }) => {
          const needsAdmin = adminOnly.includes(base)
            ? "SuperAdmin"
            : undefined;
          return (
            <React.Fragment key={base}>
              <Route
                path={`/${base}`}
                element={
                  <ProtectedRoute>
                    {React.createElement(listado)}
                  </ProtectedRoute>
                }
              />
              <Route
                path={`/${base}/Nuevo`}
                element={
                  <ProtectedRoute>{React.createElement(nuevo)}</ProtectedRoute>
                }
              />
              <Route
                path={`/${base}/Editar/:id`}
                element={
                  <ProtectedRoute>
                    {React.createElement(edicion)}
                  </ProtectedRoute>
                }
              />
            </React.Fragment>
          );
        })}
      </Routes>
    </Router>
  );
};

export default AppRoutes;
